import { generateActions } from './utils'
import { createAction } from 'redux-actions'

const registrationInviteDefinition = {
  fetchEventInfo: ['inviteId'],
  confirmTeamRepStep: ['scheduleId'],
  confirmPlayerStep: ['scheduleId'],
  confirmTeamAndDivisionSelect: [
    'teamOfficials',
    'teamId',
    'registrationId',
    'scheduleId',
    'info',
    'couponCodeId',
  ],
  confirmPlayerSelect: ['endpointInfo', 'playerInfo'],
}

export const registrationInviteActions = generateActions(
  ['REGISTRATION_INVITE'],
  registrationInviteDefinition
)

// Simple actions
export const SET_INVITE_STEP = 'REGISTRATION_INVITE.SET_STEP'
export const SET_INVITE_LOGGED = 'REGISTRATION_INVITE.SET_LOGGED'
export const SET_INVITE_SPORTS = 'REGISTRATION_INVITE.SET_SPORTS'
export const SET_NEW_TEAM_ID = 'REGISTRATION_INVITE.SET_NEW_TEAM_ID'
export const SET_TEAM_PLAYER_ROSTER_ID =
  'REGISTRATION_INVITE.SET_TEAM_PLAYER_ROSTER_ID'
export const CLEAR_INVITE_ERROR = 'REGISTRATION_INVITE.CLEAR_ERROR'

export const setInviteStep = createAction(SET_INVITE_STEP)
export const setInviteLogged = createAction(SET_INVITE_LOGGED)
export const setInviteSports = createAction(SET_INVITE_SPORTS)
export const setNewTeamId = createAction(SET_NEW_TEAM_ID)
export const setTeamPlayerRosterId = createAction(SET_TEAM_PLAYER_ROSTER_ID)
export const clearInviteError = createAction(CLEAR_INVITE_ERROR)

export default registrationInviteActions
